import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { IBranch } from '../../site/feature-modules/search-branch/models/branch.model';
import { ItemPlace } from '../../site/shared-components/item-location-overlay/models/model';
export function detectEnv() {}

@Injectable({
  providedIn: 'root',
})
export class commonService {
  isVisitor: boolean = true;
  customHeader: any;
  itemPlace$: Subject<ItemPlace> = new Subject<ItemPlace>();
  branch$: Subject<IBranch> = new Subject<IBranch>();
  loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  error$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor(private translate?: TranslateService) {}

  get isLoading(): boolean {
    return this.loading$.getValue();
  }

  get hasError(): boolean {
    return this.error$.getValue();
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }
  getCompanyIdentifier(): string {
    const companyIdentifier = localStorage.getItem('companyIdentifier');
    if (companyIdentifier) {
      return companyIdentifier;
    }
    return '';
  }

  setCompanyIdentifier(companyIdentifier: string): void {
    localStorage.setItem('companyIdentifier', companyIdentifier);
  }

  setUserName(userName: string): void {
    localStorage.setItem('userName', userName);
  }

  getUserName(): string | null {
    let userName: string | null = localStorage.getItem('userName');
    if (userName === null) {
      return '';
    }
    return userName;
  }

  setEmail(email: string): void {
    localStorage.setItem('email', email);
  }
  getEmail(): string | null {
    let email: string | null = localStorage.getItem('email');
    if (email === null) {
      return '';
    }
    return email;
  }

  setToken(token: string): void {
    localStorage.setItem('GlameraBLToken', token);
  }
  getToken(): string | null {
    let token: string | null = localStorage.getItem('GlameraBLToken');
    if (token === null) {
      return '';
    }
    return token;
  }

  /**
   * Safely read the complex auth payload stored under "tokenObject" in localStorage.
   * Returns the parsed object when valid JSON, otherwise null when missing or malformed.
   */
  get getTokenObject(): any | null {
    const raw = localStorage.getItem('tokenObject');
    if (!raw) return null;
    try { return JSON.parse(raw); } 
    catch { return null; }
  }

  setImage(image: string): void {
    localStorage.setItem('image', image);
  }
  getImage(): string | null {
    let email: string | null = localStorage.getItem('image');
    if (email === null) {
      return '';
    }
    return email;
  }

  setUserStatus(status: boolean): void {
    this.isVisitor = status;
  }
  getUserStatus(): boolean {
    return this.isVisitor;
  }

  setBranch(branch: IBranch): void {
    localStorage.setItem('branch', JSON.stringify(branch));
    this.branch$.next(branch);
  }
  getBranch(): IBranch | null {
    let branch: any = localStorage.getItem('branch');
    if (branch === null) {
      return null;
    }
    return JSON.parse(branch);
  }
  clearBranch(): void {
    localStorage.removeItem('branch');
  }

  setItemPlace(place: ItemPlace) {
    localStorage.setItem('itemPlace', place.toString());
    this.itemPlace$.next(place);
  }
  getItemPlace(): ItemPlace {
    let place: any = localStorage.getItem('itemPlace');
    // if (place === null) {
    //   this.setItemPlace(ItemPlace.OnSite);
    //   return ItemPlace.OnSite;
    // }
    return place as ItemPlace;
  }

  setLang(lang: string): void {
    this.translate?.use(lang);
    localStorage.setItem('lang', lang);
  }

  getLang(): string {
    let lang: any = localStorage.getItem('lang');
    if (lang === null) {
      return 'en';
    }
    return lang;
  }

  logOut(): void {
    localStorage.removeItem('GlameraBLToken');
    localStorage.removeItem('userName');
    localStorage.removeItem('email');
  }
}
